import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button.jsx";

export default function AboutPage() {
  return (
    <div className="min-h-screen pb-16">
      <section className="page-wrap">
        <div className="panel overflow-hidden grid lg:grid-cols-2">
          <div className="p-8 md:p-12 flex flex-col justify-center">
            <p className="chip mb-6 w-fit">Crafted In</p>
            <motion.h1
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              className="text-5xl md:text-7xl leading-[0.95]"
            >
              Chicago, Illinois
            </motion.h1>
            <p className="text-lg text-[var(--muted)] mt-6">
              We blend product design, materials engineering, and street-ready styling into one compact studio workflow.
            </p>
          </div>
          <div className="relative min-h-[420px]">
            <img 
              src="https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80"
              alt="Chicago"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          </div>
        </div>
      </section>

      <section className="page-wrap mt-10">
        <div className="panel p-8 md:p-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
            className="space-y-8"
        >
            <h2 className="text-4xl md:text-5xl">Our Story</h2>
            <p className="text-lg md:text-xl text-[var(--muted)] leading-relaxed">
              What started as one maker table became a product house spanning 3D design, fabrication, and limited apparel drops. Every release is built around utility and clear silhouettes.
          </p>
            <p className="text-lg md:text-xl text-[var(--muted)] leading-relaxed">
              We keep production intentionally small to test better ideas, iterate faster, and deliver pieces that feel considered instead of mass-produced.
          </p>
            <p className="text-lg md:text-xl text-[var(--muted)] leading-relaxed">
              The redesign now mirrors that philosophy with calmer color, stronger hierarchy, and more intentional spacing.
          </p>

            <div className="pt-2">
            <Button 
                className="btn-brand px-6 py-3"
            >
                Learn More
            </Button>
          </div>
        </motion.div>
        </div>
      </section>

      <section className="page-wrap mt-10">
        <div className="grid md:grid-cols-3 gap-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
            className="panel overflow-hidden"
        >
          <img 
            src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=800&q=80"
            alt="Craftsmanship"
              className="w-full h-80 object-cover"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
            className="panel overflow-hidden"
        >
          <img 
            src="https://images.unsplash.com/photo-1444723121867-7a241cacace9?w=800&q=80"
            alt="Design"
              className="w-full h-80 object-cover"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
            className="panel overflow-hidden"
        >
          <img 
            src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&q=80"
            alt="Materials"
              className="w-full h-80 object-cover"
          />
        </motion.div>
        </div>
      </section>
    </div>
  );
}